import React from 'react';
import PropTypes from 'prop-types';
import s from '../PointsTable/PointsTable.scss';

const CricketRankingList = props => {
  const { className, isWapView, cricketRanking, totalRankings } = props;

  let ranks = cricketRanking?.['bat-rank']?.rank;
  if (ranks && Array.isArray(ranks)) {
    ranks = ranks.slice(0, totalRankings);
  }

  if (!cricketRanking?.['bat-rank']?.['rank-type'].includes('-team')) {
    return (
      <ul className={`${s.list} ${className} ${s.listActive}`}>
        <li className={s.head}>
          <span className={s.count}>#</span>
          <span className={`${s.countryname} ${s.players}`}>Player Name</span>
          <span className={s.countryname}>Country</span>
          <span className={s.matches}>Rating</span>
          {/* {!isWapView && activeTab && <span className={s.matches}>N/r</span>}
          <span className={s.matches}>net rr</span>
          <span className={s.matches}>points</span> */}
        </li>
        {ranks &&
          Array.isArray(ranks) &&
          ranks.map(rank => (
            <li className={s.selected} key={rank.no}>
              <span className={s.count}>{rank.no}</span>
              <span className={`${s.countryname} ${s.players}`}>
                {rank['Player-name']}
              </span>
              <span className={s.countryname}>
                <span className={`${s.teamFlag} ${s[rank.Country]}`} />{' '}
                {isWapView ? null : rank.team_name}
              </span>
              <span className={s.matches}>
                <strong>{rank.Points}</strong>
              </span>
            </li>
          ))}
      </ul>
    );
  }

  return (
    <ul className={`${s.list} ${className} ${s.listActive}`}>
      <li className={s.head}>
        <span className={s.count}>#</span>
        <span className={s.countryname}>Country</span>
        <span className={s.matches}>Matches</span>
        {!isWapView && <span className={s.matches}>Points</span>}
        <span className={s.matches}>Rating</span>
        {/* {!isWapView && activeTab && <span className={s.matches}>N/r</span>}
          <span className={s.matches}>net rr</span>
          <span className={s.matches}>points</span> */}
      </li>
      {ranks &&
        Array.isArray(ranks) &&
        ranks.map(rank => (
          <li className={s.selected} key={rank.no}>
            <span className={s.count}>{rank.no}</span>
            <span className={s.countryname}>
              <span className={`${s.teamFlag} ${s[rank.shortname]}`} />{' '}
              {isWapView ? rank.shortname : rank.Country}
            </span>
            <span className={s.matches}>{rank.Matches}</span>
            {!isWapView && (
              <span className={s.matches}>
                {parseInt(rank.Points, 10).toLocaleString()}
              </span>
            )}
            <span className={s.matches}>
              <strong>{rank.Rating}</strong>
            </span>
          </li>
        ))}
    </ul>
  );
};

CricketRankingList.propTypes = {
  cricketRanking: PropTypes.arrayOf({}),
  className: PropTypes.string,
  isWapView: PropTypes.bool,
  totalRankings: PropTypes.number,
};
CricketRankingList.defaultProps = {
  cricketRanking: null,
  className: '',
  isWapView: false,
  totalRankings: 10,
};

export default React.memo(CricketRankingList);
